import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Home, Users, FileText, Building2, MapPin, MessageSquare, MailOpen, Settings as SettingsIcon, LogOut, ExternalLink } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../../components/ui/button';

const MENU = [
  { to: '/admin', icon: LayoutDashboard, label: 'Dashboard', end: true },
  { to: '/admin/properties', icon: Home, label: 'Properties' },
  { to: '/admin/locations', icon: MapPin, label: 'Locations' },
  { to: '/admin/agents', icon: Users, label: 'Advisors' },
  { to: '/admin/blog', icon: FileText, label: 'Blog Posts' },
  { to: '/admin/developers', icon: Building2, label: 'Developers' },
  { to: '/admin/testimonials', icon: MessageSquare, label: 'Testimonials' },
  { to: '/admin/inquiries', icon: MailOpen, label: 'Inquiries' },
  { to: '/admin/settings', icon: SettingsIcon, label: 'Site Settings' },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-neutral-100 flex">
      <aside className="w-64 bg-neutral-950 text-neutral-200 flex flex-col fixed inset-y-0 left-0 z-30">
        <Link to="/admin" className="flex items-center gap-3 px-5 py-5 border-b border-neutral-800">
          <img src="/assets/logo.png" alt="Terra Homes" className="h-10 w-auto bg-white rounded p-0.5" />
          <div>
            <p className="font-bold text-white text-sm leading-tight">Terra Homes</p>
            <p className="text-xs text-neutral-500">Admin CMS</p>
          </div>
        </Link>
        <nav className="flex-1 py-4 px-3 space-y-1 overflow-y-auto">
          {MENU.map((m) => {
            const Icon = m.icon;
            return (
              <NavLink
                key={m.to}
                to={m.to}
                end={m.end}
                className={({isActive}) =>
                  'flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors ' +
                  (isActive ? 'bg-[#DC2626] text-white' : 'text-neutral-400 hover:text-white hover:bg-neutral-900')
                }
              >
                <Icon className="w-4 h-4" /> {m.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="p-3 border-t border-neutral-800">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-2 px-3 py-2 text-sm text-neutral-400 hover:text-white"><ExternalLink className="w-4 h-4" /> View Site</a>
          <button onClick={onLogout} className="w-full flex items-center gap-2 px-3 py-2 text-sm text-neutral-400 hover:text-red-400"><LogOut className="w-4 h-4" /> Sign Out</button>
          <p className="px-3 mt-2 text-xs text-neutral-600">Signed in as <span className="text-neutral-400">{user?.username}</span></p>
        </div>
      </aside>
      <main className="flex-1 ml-64 p-6 lg:p-8">
        <Outlet />
      </main>
    </div>
  );
}
